import { render } from "./AddTrainingSession.vue?vue&type=template&id=657b0db8&scoped=true"
import script from "./AddTrainingSession.vue?vue&type=script&lang=js"
export * from "./AddTrainingSession.vue?vue&type=script&lang=js"

import "./AddTrainingSession.vue?vue&type=style&index=0&id=657b0db8&lang=scss&scoped=true"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657b0db8"]])

export default __exports__